<template>
  <Register></Register>
</template>

<script>
// @ is an alias to /src
import Register from "@/components/Register.vue";
export default {
  name: "RegisterView",
  components: { Register }
};
</script>
